import {TableContainer as MUITableContainer} from '@mui/material'
import React from 'react'

interface TableContainerProps extends React.ComponentProps<typeof MUITableContainer> {}

export const TableContainer: React.FC<TableContainerProps> = (props) => {
  return <MUITableContainer {...props} />
}
